/**
 * Handles the prioritization of network requests.
 */
export class RequestManager {
    constructor(globeTileOptions, tilesetTileOptions) {
        this.queue = [];
        this.inFlight = [];
        this.globeTileOptions = globeTileOptions;
        this.tilesetTileOptions = tilesetTileOptions;
    }
    /**
     * Count the number of requests for each type in flight.
     *
     * @param type
     * @returns
     */
    countInFlight(type) {
        let count = 0;
        for (const handle of this.inFlight) {
            if (handle.type === type) {
                count++;
            }
        }
        return count;
    }
    /**
     * Test to see if a request handle can be promoted to in-flight.
     *
     * @param handle
     * @returns
     */
    canStartRequest(handle) {
        const globeCount = this.countInFlight("globe");
        const tilesetCount = this.countInFlight("tileset");
        const priorityCount = this.countInFlight("priority");
        if (handle.type === "globe" && (globeCount >= this.globeTileOptions.maxInFlight || priorityCount > 0)) {
            return false;
        }
        if (handle.type === "tileset" && (tilesetCount >= this.tilesetTileOptions.maxInFlight || priorityCount > 0)) {
            return false;
        }
        return true;
    }
    /**
     * Remove a handle in flight.
     *
     * @param handle
     */
    removeInFlight(handle) {
        const index = this.inFlight.findIndex((query) => query === handle);
        if (index < 0) {
            throw new Error("Could not remove completed in-flight request... Wtf???");
        }
        this.inFlight.splice(index, 1);
    }
    /**
     * Update the request manager.
     */
    update() {
        // Sort the queue based on the sort key
        this.queue = this.queue.sort((a, b) => a[0] - b[0]);
        // Initiate requests that satisfy the criteria
        for (const [sortKey, resolve, reject, handle] of this.queue) {
            if (this.canStartRequest(handle)) {
                this.inFlight.push(handle);
                handle.status = "inflight";
                resolve(undefined);
            }
            else {
                handle.status = "cancelled";
                reject("Request Cancelled");
            }
        }
        this.queue.length = 0;
    }
    /**
     * Enqueue a network request.
     *
     * @param type
     * @param sortKey
     * @param callback
     * @returns
     */
    queueRequest(type, callback, sortKey = 0) {
        let resolveFn;
        let rejectFn;
        const progressGate = new Promise((resolve, reject) => {
            resolveFn = resolve;
            rejectFn = reject;
        });
        const promise = progressGate.then(callback).then((result) => {
            handle.status = "complete";
            this.removeInFlight(handle);
            return result;
        }, (reason) => {
            if (reason !== "Request Cancelled") {
                console.error(reason);
                handle.status = "complete";
                this.removeInFlight(handle);
            }
        });
        let handle;
        handle = {
            type,
            status: "queued",
            promise,
        };
        this.queue.push([sortKey, resolveFn, rejectFn, handle]);
        return handle;
    }
}
